"use client";
import { cn } from "@ui/lib/utils";
import { useInView } from "motion/react";
import { useRef } from "react";

interface RenderWhenInViewProps {
  amount?: "all" | "some" | number;
  children: React.ReactNode;
  className?: string;
  once?: boolean;
}

export function RenderWhenInView({ children, once = true, className, amount = "some" }: RenderWhenInViewProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once, amount });

  return (
    <div className={cn("w-full", className)} ref={ref}>
      {isInView && children}
    </div>
  );
}
